import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { ProductCategoryBase } from '../../../entities/@products/ProductCategory/ProductCategory';
import { AsyncReduxState, initialAsyncReduxState } from '../../defaults';

export type ProductCategoriesState = AsyncReduxState<{
    productCategories: ProductCategoryBase[];
}>;

const initialState: ProductCategoriesState = {
    ...initialAsyncReduxState,
    productCategories: [],
};

const productCategoriesSlice = createSlice({
    name: 'productCategoriesSlice',
    initialState,
    reducers: {
        setData(state, action: PayloadAction<ProductCategoriesState>): ProductCategoriesState {
            return {
                ...action.payload,
            };
        },
        setIsLoading(state, action: PayloadAction<boolean>): ProductCategoriesState {
            return {
                ...state,
                isLoading: action.payload,
            };
        },
        setHasFetched(state, action: PayloadAction<boolean>): ProductCategoriesState {
            return {
                ...state,
                hasFetched: action.payload,
            };
        },
        setIsSuccessful(state, action: PayloadAction<boolean>): ProductCategoriesState {
            return {
                ...state,
                isSuccessful: action.payload,
            };
        },
        setError(state, action: PayloadAction<string>): ProductCategoriesState {
            return {
                ...state,
                error: action.payload,
            };
        },
        setProductCategories(state, action: PayloadAction<ProductCategoryBase[]>): ProductCategoriesState {
            return {
                ...state,
                productCategories: action.payload,
            };
        },
    },
});

export const {
    setData,
    setIsLoading,
    setHasFetched,
    setIsSuccessful,
    setError,
    setProductCategories,
} = productCategoriesSlice.actions;

export default productCategoriesSlice;
